import { atom } from 'jotai';
import { atomWithStorage } from 'jotai/utils';

export function atomWithToggle(initialValue) {
  const anAtom = atom(initialValue, (get, set, nextValue) => {
    const update = nextValue ?? !get(anAtom);
    set(anAtom, update);
  });

  return anAtom;
}

export function atomWithToggleAndStorage(name, initialValue) {
  const anAtom = atomWithStorage(name, initialValue);
  const derivedAtom = atom(
    (get) => get(anAtom),
    (get, set, nextValue) => {
      const update = nextValue ?? !get(anAtom);
      set(anAtom, update);
    },
  );
  derivedAtom.debugLabel = name;

  return derivedAtom;
}

export default { atomWithToggle };
